import React, { useContext } from 'react';
import { string, bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import { ApplianceBundlesProvider, ApplianceBundlesComponent } from './components';

export const ApplianceBundles = ({ itemId, isB2BCustomer }) => {
  const { isServer, channel, isConsumerApp } = useContext(ExperienceContext);
  const { defaultVariables } = useContext(QueryContext) || {};

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <QueryProvider defaultVariables={newDefaultVariables} cacheKey="appliance-bundles">
      <ApplianceBundlesProvider
        itemId={itemId}
        isB2BCustomer={isB2BCustomer}
        isServer={isServer}
        channel={channel}
        isConsumerApp={isConsumerApp}
      >
        <ApplianceBundlesComponent />
      </ApplianceBundlesProvider>
    </QueryProvider>
  );
};

ApplianceBundles.propTypes = {
  itemId: string.isRequired,
  isB2BCustomer: bool
};

ApplianceBundles.defaultProps = {
  isB2BCustomer: false
};
